// components/Notification.js
import React from 'react';
import '../Maintenance-styles/Notification.css';

const Notification = ({ message, onClose }) => (
  <div className="notification">
    {message}
    <button className="close-notification" onClick={onClose}>
      &times;
    </button>
  </div>
);

export default Notification;
